import React, { useRef } from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { useSelector } from "react-redux";
import { getTheme } from "../../redux/themeSlice";
import {
  CheckboxProps,
  StyledCheckboxProps,
} from "../../interfaces/customElementsInterfaces";
import { getPropsByVariant } from "../../gridUtils/uiUtil";

const HiddenCheckbox = styled.input`
  display: none;
`;

const StyledCheckbox = styled.div<StyledCheckboxProps & { color: string }>`
  color: ${({ theme, color }) =>
    (theme[color as keyof typeof theme] as { main: string })?.main ||
    "inherit"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  line-height: 1;
  flex-shrink: 0;
  cursor: pointer;
`;

const Checkbox: React.FC<CheckboxProps> = React.memo(
  ({ id, name, value, checked, onChange, color }) => {
    const theme = useSelector(getTheme);
    const variant = "dark";
    const { backgroundColor, borderColor } = getPropsByVariant({
      variant,
      color,
      theme,
      checked,
    });

    const hiddenCheckboxRef = useRef<HTMLInputElement | null>(null);

    const handleCheckboxChange = (event: React.MouseEvent<HTMLDivElement>) => {
      event.preventDefault();
      if (hiddenCheckboxRef.current) {
        hiddenCheckboxRef.current.checked = !checked;
        onChange({
          target: hiddenCheckboxRef.current,
        } as React.ChangeEvent<HTMLInputElement>);
      }
    };

    return (
      <>
        <HiddenCheckbox
          ref={hiddenCheckboxRef}
          id={id}
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={(event) => onChange(event)}
        />
        <StyledCheckbox
          onClick={handleCheckboxChange}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
          color={color}
          checked={false}
        >
          {checked ? (
            <FontAwesomeIcon icon={faCheckSquare} fixedWidth />
          ) : (
            <FontAwesomeIcon icon={faSquare} fixedWidth />
          )}
        </StyledCheckbox>
      </>
    );
  },
);

export default Checkbox;
